module.exports = "/assets/data/d96919804de7aa931528f105b25e26ca-CT18.data.json";